// Material Compoents
import { Box } from "@mui/material";

// Highchart
import Highcharts from "highcharts";
import HC_more from "highcharts/highcharts-more";
import HighchartsReact from "highcharts-react-official";

// Components
import CustomiseLabels from "components/Charts/CustomiseLabelsLegacy";

import "assets/styles/components/highcharts.css";

// Hooks
import useFunctional from "./useFunctional";
import { IBaseChartProps } from "components/Charts/chart.types";

HC_more(Highcharts);

const Functional = ({ width, height, getData, hideRefSeries }: IBaseChartProps): JSX.Element => {
    const { chartOptions, chartData, chartRef, setShowRoles, showRoles, showNames, setShowNames } = useFunctional({
        width,
        height,
        getData,
        hideRefSeries,
    });

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{
                width: "100%",
                height: "100%",
                margin: "auto",
                position: "relative",
                overflow: "hidden",
            }}
        >
            {chartData && <HighchartsReact highcharts={Highcharts} options={chartOptions} ref={chartRef} />}
            <CustomiseLabels
                setShowRoles={setShowRoles}
                showRoles={showRoles}
                showNames={showNames}
                setShowNames={setShowNames}
            />
        </Box>
    );
};

export default Functional;
